export const getPcDom = (Comp) => {
  return (
    <div className="content">
      <div className="menu-top">
        <div id="player" className="player" />
        <div id="menu" className="menu" />
      </div>
      <div id="menu2" className="menu-bottom"></div>
      <Comp />
    </div>
  );
};
